import { render } from "./PricingTable.vue?vue&type=template&id=02aded8c&ts=true"
import script from "./PricingTable.vue?vue&type=script&lang=ts"
export * from "./PricingTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__